// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"0f6ccc35","729":"fcf92a98","758":"991670b0"}[chunkId] + ".chunk.css";
};